import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/process-session", { session_id: sessionId });
        setUser(data);
        // Clean the hash and go to dashboard
        window.history.replaceState({}, "", "/");
        navigate("/", { replace: true, state: { user: data } });
      } catch (e) {
        console.error("Auth failed", e);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="loading-page" data-testid="auth-callback-loading">
      <div style={{ textAlign: "center" }}>
        <div className="spinner" />
        <div style={{ marginTop: 14, color: "var(--text-2)", fontSize: 13 }}>Signing you in…</div>
      </div>
    </div>
  );
}
